import {
  AfterViewInit, Component, ElementRef, OnChanges, OnInit
} from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { IdtSharedRenderService } from 'render/render-shared/idt-shared-render.service';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { Observable } from 'rxjs';
import { AmandaOptions, AssetsSharedService } from 'shared/services/assets-shared.service';

import { PieceMarqueeSettings } from './models/piece-marquee.models';


@Component({
  selector: 'piece-marquee-render',
  templateUrl: './piece-marquee-render.component.html',
  styleUrls: ['./piece-marquee-render.component.scss']
})
export class PieceMarqueeRenderComponent
  extends BaseRenderComponent<PieceMarqueeSettings>
  implements OnInit, OnChanges, AfterViewInit {

  public orientation$!: Observable<string>;

  public marqueeElement: HTMLDivElement | null = null;
  public dir = document.body.dir;
  public speed = this.settings?.general?.speed;
  public demo = this.settings?.general?.field01;

  constructor(
    private readonly elRef: ElementRef<HTMLElement>,
    private readonly idtSharedRenderService: IdtSharedRenderService,
    private readonly assetsSharedService: AssetsSharedService,
    private readonly renderConfigurationService: RenderConfigurationService

  ) {
    super();
    this.orientation$ = this.idtSharedRenderService.screenOrientation$;
  }

  public ngOnInit(): void {
    this.refreshStyles();
    this.getImgPosition();
  }

  public ngOnChanges(): void {
    this.speed = this.settings.general?.speed;
    this.getImgPosition();
    this.refreshStyles();
  }

  public ngAfterViewInit() {
    this.marqueeElement = this.elRef.nativeElement.querySelector('div.marquee');
    this.marquee();
  }

  public getImgPosition() {
    const marqueeImgArray = [
      this.settings.general?.image01,
      this.settings.general?.image02,
      this.settings.general?.image03,
      this.settings.general?.image04,
      this.settings.general?.image05
    ];
    marqueeImgArray.forEach((item, index) => {
      this.orientation$.subscribe((orientation) => {
        const imageSrc = this.getBackgroundImageSrc(orientation, item?.imgLandscape?.image, item?.imgPortrait?.image);
        this.elRef.nativeElement.style.setProperty(`--srcImg${index.toString()}`, `url('${imageSrc}')`);
        this.elRef.nativeElement.style.setProperty('--widthBGDesktop', `${this.settings.general?.responsiveSize.heightDesktop}`);
        this.elRef.nativeElement.style.setProperty('--widthBGMobile', `${this.settings.general?.responsiveSize.heightMobile}`);
      });
    });
  }

  public getBackgroundImageSrc(
    orientation: string,
    imgLand: string | null | undefined,
    imgPort: string | null | undefined
  ): string | undefined {
    const assetsUrl = this.renderConfigurationService.config.assetsUrl;

    const image = orientation === 'landscape' ? imgLand : imgPort;
    const akamaiOptions: AmandaOptions = {
      isWidthParamEnabled: this.renderConfigurationService.config.amandaImageVideoManagerEnabled,
      width: this.assetsSharedService.getWidth(this.elRef)
    };
    return this.assetsSharedService.getAssetUrl(image!, assetsUrl, akamaiOptions);
  }

  private refreshStyles(): void {
    this.elRef.nativeElement.style.setProperty('--bgColorMarquee', `${this.settings.general?.backgroundColor}`);
    this.elRef.nativeElement.style.setProperty('--customPaddingTop', `${this.settings.general?.customPaddingTop}`);
    this.elRef.nativeElement.style.setProperty('--customPaddingRight', `${this.settings.general?.customPaddingRight}`);
    this.elRef.nativeElement.style.setProperty('--customPaddingBottom', `${this.settings.general?.customPaddingBottom}`);
    this.elRef.nativeElement.style.setProperty('--customPaddingLeft', `${this.settings.general?.customPaddingLeft}`);
    this.elRef.nativeElement.style.setProperty('--customPaddingBottom', `${this.settings.general?.customPaddingBottom}`);
    this.elRef.nativeElement.style.setProperty('--gap', `${this.settings.general?.gap}`);
    this.elRef.nativeElement.style.setProperty('--heightDesktop', `${this.settings.general?.responsiveSize.heightDesktop}`);
    this.elRef.nativeElement.style.setProperty('--widthDesktop', `${this.settings.general?.responsiveSize.widthDesktop}`);
    this.elRef.nativeElement.style.setProperty('--heightMobile', `${this.settings.general?.responsiveSize.heightMobile}`);
    this.elRef.nativeElement.style.setProperty('--widthMobile', `${this.settings.general?.responsiveSize.widthMobile}`);
  }

  private marquee(): void {
    if (!this.marqueeElement) {
      return;
    }

    let tick: number = 1;
    const value: number = parseFloat(`${this.speed}`);

    for (let i = 0; i < 6; i++) {
      this.marqueeElement.innerHTML += this.marqueeElement.innerHTML;
    }
    const innerTags: NodeListOf<HTMLDivElement> = this.marqueeElement.querySelectorAll('div.inner');
    innerTags.forEach((inner: HTMLDivElement, index: number) => {
      inner.style.left = `${inner.offsetWidth * index}px`;
    });

    const ticker = () => {
      if (this.dir === 'rtl') {
        if (this.settings.general?.directionMode) {
          tick += value;
        } else {
          tick += Math.abs(value);
        }
      } else {
        if (this.settings.general?.directionMode) {
          tick += Math.abs(value);
        } else {
          tick += value;
        }
      }
      innerTags.forEach((inner: HTMLDivElement, index: number) => {
        const width: number = inner.offsetWidth;
        const normalizedMarqueeX: number = ((tick % width) + width) % width;
        const pos: number = width * (index - 1) + normalizedMarqueeX;
        inner.style.left = `${pos}px`;
      });
      requestAnimationFrame(ticker);
    };

    ticker();
  }

}
